export const log = (arg) => {
  // if(process.env.NODE_ENV === 'production'){
  //   return
  // }
  var now = (window.performance.now() / 1000).toFixed(3)
  console.log(`${now}: ${arg}`)
}
